/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import { differenceInMinutes, parseISO } from "date-fns";
import { format as tzFormat, utcToZonedTime } from "date-fns-tz";

export const formatUserLocalTime = (dateTime) => {
  if (dateTime.slice(-1) !== "Z") {
    dateTime = dateTime + "Z";
  }
  const parsedDateTime = parseISO(dateTime);
  const formattedDateTime = tzFormat(parsedDateTime, "MM/dd HH:mm (z)");

  return formattedDateTime;
};

export const formatUserLocalTimeWithYear = (dateTime) => {
  if (dateTime.slice(-1) !== "Z") {
    dateTime = dateTime + "Z";
  }
  const parsedDateTime = parseISO(dateTime);
  const formattedDateTime = tzFormat(parsedDateTime, "MM/dd/yyyy HH:mm (z)");

  return formattedDateTime;
};

export const utcToZonedDateTime = (utcDateTime, timeZone) => {
  if (!timeZone) {
    timeZone = "UTC";
  }

  const parsedUtcDateTime = parseISO(utcDateTime + "Z");
  const zonedDateTime = utcToZonedTime(parsedUtcDateTime, timeZone);
  return zonedDateTime;
};

export const formatTimeWithTimeZone = (utcTime, timeZone) => {
  if (!timeZone) {
    timeZone = "UTC";
  }

  const parsedUtcTime = parseISO(utcTime + "Z");
  const originTime = utcToZonedTime(parsedUtcTime, timeZone);
  const formattedOriginTime = tzFormat(originTime, "MM/dd HH:mm (z)", {
    timeZone,
  });
  return formattedOriginTime;
};

export const formatTimeWithTimeZoneAndYear = (utcTime, timeZone) => {
  if (!timeZone) {
    timeZone = "UTC";
  }

  const parsedUtcTime = parseISO(utcTime + "Z");
  const originTime = utcToZonedTime(parsedUtcTime, timeZone);
  const formattedOriginTime = tzFormat(originTime, "MM/dd/yyyy HH:mm", {
    timeZone,
  });
  return formattedOriginTime;
};

export const getTimeSpanRemainingStringFromUTC = (utcTime) => {
  const parsedLocal = parseISO(utcTime + "Z");
  const now = new Date();
  const isNeg = now > parsedLocal;
  const diffInMin = Math.abs(differenceInMinutes(now, parsedLocal));
  const hours = Math.floor(diffInMin / 60);
  const minutes = diffInMin % 60;
  return `${isNeg ? "-" : ""}${hours > 9 ? hours : "0" + hours}:${
    minutes > 9 ? minutes : "0" + minutes
  }`;
};

export const formatDate = (utcDate, timeZone) => {
    if (!timeZone) {
    timeZone = "UTC";
  }

  const parsedUtcTime = parseISO(utcDate + "Z");
  const destinationDate = utcToZonedTime(parsedUtcTime, timeZone);
  const formattedDestinationDate = tzFormat(destinationDate, "MM/dd", {
    timeZone,
  });
  return formattedDestinationDate;
};

export const formatTime = (utcTime, timeZone) => {
    if (!timeZone) {
    timeZone = "UTC";
  }

  const parsedUtcTime = parseISO(utcTime + "Z");
  const originTime = utcToZonedTime(parsedUtcTime, timeZone);
  const formattedOriginTime = tzFormat(originTime, "HH:mm", { timeZone });
  return formattedOriginTime;
};

export const formatTimeZone = (utcTime, timeZone) => {
    if (!timeZone) {
    timeZone = "UTC";
  }
  
  const parsedUtcTime = parseISO(utcTime + "Z");
  const originTime = utcToZonedTime(parsedUtcTime, timeZone);
  const formattedTimeZone = tzFormat(originTime, "z", { timeZone });
  return formattedTimeZone;
};
